
import React from "react";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";

import Forbes1 from "../../../assets/noticias/Forbes1.png"
import Forbes2 from "../../../assets/noticias/Forbes2.png"
import Forbes3 from "../../../assets/noticias/Forbes3.png"
import Forbes4 from "../../../assets/noticias/Forbes4.png"

import "./NoticiasDestacadas.css";

// Agrega aquí las cuatro noticias más importantes de Vemasmas.
const noticias = [
    {
        id: 1,
        categoria: "Oscar Fredy González",
        titulo: "El big bang de la inteligencia de datos.",
        descripcion:
            "Conoce la visión de Oscar Fredy González Rivera y Vemasmas en Forbes sobre el futuro de la inteligencia de datos.",
        imagen: Forbes1,
        imagenAlt: "Imagen de la primera noticia",
        enlace: "https://forbes.com.mx/ad-el-big-bang-de-la-inteligencia-de-datos/",
    },
    {
        id: 2,
        categoria: "Oscar Fredy González",
        titulo: "Un viaje al futuro por medio de nanosatélites.",
        descripcion:
            "Forbes destaca a Vemasmas y Oscar Fredy González Rivera por su innovación con nanosatélites y visión de futuro.",
        imagen: Forbes2,
        imagenAlt: "Imagen de la segunda noticia",
        enlace: "https://forbes.com.mx/ad-un-viaje-al-futuro-por-medio-de-nanosatelites-vemasmas/",
    },
    {
        id: 3,
        categoria: "Oscar Fredy González",
        titulo: "El uso de la tecnología para simplificar el pago de impuestos.",
        descripcion:
            "Timbox, impulsada por Vemasmas, fue destacada en Forbes por su innovación en facturación electrónica.",
        imagen: Forbes3,
        imagenAlt: "Imagen de la tercera noticia",
        enlace: "https://forbes.com.mx/ad-timbox-uso-de-la-tecnologia-para-pago-de-impuestos/",
    },
    {
        id: 4,
        categoria: "Oscar Fredy González",
        titulo: "Empresas Líderes en México.",
        descripcion:
            "Un logro que reafirma la visión de Oscar Fredy González Rivera como líder en tecnología y transformación digital.",
        imagen: Forbes4,
        imagenAlt: "Imagen de la cuarta noticia",
        enlace: "https://online.fliphtml5.com/kpoib/yqml/#p=142",
    },
];

function NoticiasDestacadas() {
    return (
        <section className="noticias-destacadas" id="noticias">
            <div className="noticias-destacadas__header">
                <div>
                    <span className="noticias-destacadas__eyebrow">
                        V++ / ACTUALIDAD
                    </span>

                    <h2>
                        Lo que estamos
                        <br />
                        <span>transformando.</span>
                    </h2>
                </div>

                <p className="noticias-destacadas__intro">
                    Proyectos, alianzas e iniciativas que reflejan
                    nuestra visión de innovación y tecnología.
                </p>
            </div>

            <div className="noticias-destacadas__grid">
                {noticias.map((noticia, index) => (
                    <article
                        className="noticia-card"
                        key={noticia.id}
                    >
                        <a
                            className="noticia-card__link"
                            href={noticia.enlace}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Leer noticia: ${noticia.titulo}`}
                        >
                            <div className="noticia-card__image">
                                <img
                                    src={noticia.imagen}
                                    alt={noticia.imagenAlt}
                                    loading={index === 0 ? "eager" : "lazy"}
                                />

                                <span className="noticia-card__number">
                                    {String(noticia.id).padStart(2, "0")}
                                </span>

                                <span className="noticia-card__icon">
                                    <FaArrowUpRightFromSquare />
                                </span>
                            </div>

                            <div className="noticia-card__content">
                                <span className="noticia-card__category">
                                    {noticia.categoria}
                                </span>

                                <h3>{noticia.titulo}</h3>

                                <p>{noticia.descripcion}</p>

                                <span className="noticia-card__read-more">
                                    Leer nota
                                    <span aria-hidden="true">↗</span>
                                </span>
                            </div>
                        </a>
                    </article>
                ))}
            </div>

            <div className="noticias-destacadas__footer">
                <span>INNOVACIÓN EN MOVIMIENTO</span>
                <span>01 — 04</span>
            </div>
        </section>
    );
}

export default NoticiasDestacadas;
